export default __webpack_public_path__ + "static/media/hydro_dapp_store_logo.6dd30d03.png";